var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["down"] = "ArrowDown";
    KeyboardKey["end"] = "End";
    KeyboardKey["enter"] = "Enter";
    KeyboardKey["escape"] = "Escape";
    KeyboardKey["home"] = "Home";
    KeyboardKey["left"] = "ArrowLeft";
    KeyboardKey["right"] = "ArrowRight";
    KeyboardKey["space"] = " ";
    KeyboardKey["tab"] = "Tab";
    KeyboardKey["up"] = "ArrowUp";
})(KeyboardKey || (KeyboardKey = {}));
var LegacyKeyboardKey;
(function (LegacyKeyboardKey) {
    LegacyKeyboardKey["down"] = "Down";
    LegacyKeyboardKey["end"] = "End";
    LegacyKeyboardKey["enter"] = "Enter";
    LegacyKeyboardKey["escape"] = "Esc";
    LegacyKeyboardKey["home"] = "Home";
    LegacyKeyboardKey["left"] = "Left";
    LegacyKeyboardKey["right"] = "Right";
    LegacyKeyboardKey["space"] = "Spacebar";
    LegacyKeyboardKey["tab"] = "Tab";
    LegacyKeyboardKey["up"] = "Up";
})(LegacyKeyboardKey || (LegacyKeyboardKey = {}));

export { KeyboardKey, LegacyKeyboardKey };
